import Storage from './Storage'
import RoleUtil from "./RoleUtil";

const User = {

  isAdvisor() {
    return this.isDuiServiceAdvisor() || this.isDuiAdmin();
  },

  isCallCenterAgent() {
    const user = Storage.getItem('user');
    return RoleUtil.CALL_CENTER_AGENT === user.role;
  },

  isDuiAdmin() {
    const user = Storage.getItem('user');
    return RoleUtil.DUI_ADMIN === user.role;
  },

  isDuiServiceAdvisor() {
    const user = Storage.getItem('user');
    return RoleUtil.DUI_SERVICE_ADVISOR === user.role;
  },

};

export default User;
